import dayjs from "dayjs"
import Vue from "vue"

// function average(nums) {
//   if (nums.length==0) return 0
//   return nums.reduce((a, b) => (a + b)) / nums.length;
// }

function max(nums) {
  if (nums.length === 0) return 0
  return Math.max(...nums)
}

const trendData = (widget, formattingOptions, timespan) => {
  const measurements = widget.metric.bucketMeasurements
  if (measurements.length === 0) return [['Date', widget.metric.name], ['No data']]
  
  const firstDate = new Date(measurements[0].createdAt)
  const lastDate = new Date()
  // const lastDate = new Date(measurements[measurements.length-1].createdAt)

  let currDay = dayjs(firstDate).startOf(timespan)
  let endCurrDay = dayjs(firstDate).endOf(timespan)
  const endLastDay = dayjs(lastDate).endOf(timespan)

  let noIntervals = 0
  if (timespan === 'day' || timespan === 'week' || timespan === 'month') {
    noIntervals = Math.ceil(endLastDay.diff(currDay, timespan, true))
  } else {
    throw new Error(`Unsupported timespan: ${timespan}`)
  }
  // const noDays = Math.ceil((endLastDay.toDate().getTime() - currDay.toDate().getTime()) / 1000 / 86400 / 7)

  // console.log({currDay: currDay.toISOString(), endCurrDay: endCurrDay.toISOString(), endLastDay: endLastDay.toISOString(), noIntervals})

  const dayValues = []
  for (let day = 0; day < noIntervals; day++) {
    const currDayValues = []
    while (measurements.length > 0) {
      const measurement = measurements[0]
      const measurementTS = dayjs(measurement.createdAt)
      if ((measurementTS.isAfter(currDay) || measurementTS.isSame(currDay)) && measurementTS.isBefore(endCurrDay)) {
        const spliced = measurements.splice(0, 1)
        const measurement = spliced[0]
        currDayValues.push(measurement.measurement)
      } else if (measurementTS.isAfter(currDay)) {
        break
      }          
    }
    if (currDayValues.length === 0) {
      currDayValues.push(dayValues[dayValues.length - 1][1].v)
    }
    const avgValue = max(currDayValues)
    const chartValue = { v: avgValue, f: `${formattedValue(avgValue, formattingOptions)}`}

    dayValues.push([currDay.toDate(), chartValue])

    currDay = currDay.add(1, timespan)
    endCurrDay = currDay.add(1, timespan)
  }
  return [['Date', widget.metric.name]].concat(dayValues)
}

const generateChartData = (widget, formattingOptions) => {
  if (widget.type === "trend") {
    return trendData(widget, formattingOptions, widget.timeInterval || 'day')
  } else if (widget.type === 'piechart') {
    const chartData = [['Group', 'Value']]
    const latestValues = {}
    let latestDay
    for (const measurement of widget.metric.bucketMeasurements) {
      const currDay = dayjs(measurement.createdAt).startOf('day')
      if (!latestDay || currDay.isAfter(latestDay)) {
        latestDay = currDay
      }

      const currDayCode = currDay.format('YYYYMMDD')
      if (!latestValues[currDayCode]) {
        latestValues[currDayCode] = {}
      }
      latestValues[currDayCode][measurement.group] = { v: measurement.measurement, f: `${formattedValue(measurement.measurement, formattingOptions)}`}
    }
    const latestDayCode = latestDay.format('YYYYMMDD')
    const rows = Object.keys(latestValues[latestDayCode]).map(group => [group, latestValues[latestDayCode][group]])
    return chartData.concat(rows)
  } else {
    return widget.metric.bucketMeasurements.map(bm => bm.measurement)
  }
}

const formattedValue = (value, formattingOptions) => {
  if (formattingOptions.currencySymbol) {
    return `£${value.toFixed(2)}`
  } else {
    return `${value}`
  }
}

const handleWidgetMutation = (state, widget, mutateWidgetList) => {
  if (widget.dashboardSectionId) {
    // Update list of widgets for a dashboard section
    const dashboardSectionIndex = state.dashboardSections.findIndex(ds => ds.id === widget.dashboardSectionId)
    if (dashboardSectionIndex !== -1) {
      const newWidgetList = Object.assign([], state.dashboardSections[dashboardSectionIndex].widgets)
      mutateWidgetList(newWidgetList)
      Vue.set(state.dashboardSections[dashboardSectionIndex], 'widgets', newWidgetList)
    }
  } else {
    // Update list of widgets that do not belong to a section
    const newWidgetList = Object.assign([], state.widgetsWithoutSection)
    mutateWidgetList(newWidgetList)
    Vue.set(state, 'widgetsWithoutSection', newWidgetList)
  }
}

export default {
  setMetricsLoading(state, loading) {
    state.loading = loading
  },
  addNewWidget(state, { widget, options }) {
    widget.chartData = generateChartData(widget, options)
    widget.chartOptions = {}

    handleWidgetMutation(state, widget, (newWidgetList) => {
      newWidgetList.push(widget)
    })
  },
  deleteWidget(state, widget) {
    handleWidgetMutation(state, widget, (newWidgetList) => {
      const widgetToRemove = newWidgetList.findIndex(w => w.id === widget.id)
      newWidgetList.splice(widgetToRemove, 1)
    })
  },
  updateWidget(state, { widget, options }) {
    handleWidgetMutation(state, widget, (newWidgetList) => {
      const widgetToUpdate = newWidgetList.findIndex(w => w.id === widget.id)
      widget.chartData = generateChartData(widget, options)
      widget.chartOptions = {}
      newWidgetList[widgetToUpdate] = widget
    })
  },
  reorderWidgets(state, newWidgetList) {
    Vue.set(state, 'all', newWidgetList)
  },
  updateWidgets(state, widgetsAndOptions) {
    const widgets = []
    for (const index in widgetsAndOptions) {
      const widget = widgetsAndOptions[index].widget
      const options = widgetsAndOptions[index].options

      widget.chartData = generateChartData(widget, options)
      widget.chartOptions = {}
      widgets.push(widget)
    }
    const widgetsWithoutSection = widgets.filter(w => !w.dashboardSectionId)
    Vue.set(state, 'all', widgets)
    Vue.set(state, 'widgetsWithoutSection', widgetsWithoutSection)
  },
  updateDashboardSections(state, { dashboardSections, widgetAndOptions }) {
    dashboardSections.forEach(ds => {
      ds.widgets.forEach(dsWidget => {
        const widgetOptions = widgetAndOptions.find(wOptions => wOptions.widget.id === dsWidget.id)
        if (widgetOptions) {
          dsWidget.chartData = generateChartData(dsWidget, widgetOptions)
          dsWidget.chartOptions = {}
        }
      })
    })
    Vue.set(state, 'dashboardSections', dashboardSections)
  },
  addNewDashboardSection(state, dashboardSection) {
    const updatedDashboardSections = Object.assign(state.dashboardSections, [])
    updatedDashboardSections.push(dashboardSection)
    Vue.set(state, 'dashboardSections', updatedDashboardSections)
  },
  updateDashboardSection(state, dashboardSection) {
    const targetSection = state.dashboardSections.findIndex(ds => ds.id === dashboardSection.id)
    if (targetSection !== -1) {
      const updatedSections = Object.assign([], state.dashboardSections)
      updatedSections[targetSection].name = dashboardSection.name
      Vue.set(state, 'dashboardSections', updatedSections)
    }
  },
  deleteDashboardSection(state, id) {
    const targetSection = state.dashboardSections.findIndex(ds => ds.id === id)
    if (targetSection !== -1) {
      // Move widgets to 'widgetsWithoutSection'
      const sectionWidgets = state.dashboardSections[targetSection].widgets
      sectionWidgets.forEach(sWidget => { sWidget.dashboardSectionId = null })
      const updatedWidgetsWithoutSection = Object.assign(sectionWidgets, state.widgetsWithoutSection)
      Vue.set(state, 'widgetsWithoutSection', updatedWidgetsWithoutSection)

      const updatedSections = Object.assign([], state.dashboardSections)
      updatedSections.splice(targetSection, 1)
      Vue.set(state, 'dashboardSections', updatedSections)
    }
  }
}
